<section class="mass-os-itineraries">
  <div class="mass-os-itineraries__toolbar">
    <mat-checkbox
      [checked]="isAllSelected()"
      [indeterminate]="isAllIndeterminate()"
      (change)="toggleAll()"
    >
      Seleccionar todos
    </mat-checkbox>
    <button
      type="button"
      mat-icon-button
      class="mass-os-itineraries__expand-all"
      [class.mass-os-itineraries__expand-all--open]="allExpanded"
      [attr.aria-expanded]="allExpanded"
      [matTooltip]="allExpanded ? 'Contraer todos' : 'Expandir todos'"
      matTooltipPosition="right"
      (click)="toggleAllExpand()"
    >
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
    <span class="mass-os-itineraries__counts" *ngIf="selectedCount > 0">
      <span class="mass-os-itineraries__count">
        {{ selectedCount }} servicio{{ selectedCount === 1 ? '' : 's' }}
        seleccionado{{ selectedCount === 1 ? '' : 's' }} para OS
      </span>
      <span
        *ngIf="selectedTicketCount > 0"
        class="mass-os-itineraries__ticket-count"
        title="Tickets seleccionados para OS"
      >
        <mat-icon>confirmation_number</mat-icon>
        {{ selectedTicketCount }} ticket{{
          selectedTicketCount === 1 ? '' : 's'
        }} seleccionado{{ selectedTicketCount === 1 ? '' : 's' }}
      </span>
    </span>

    <span class="mass-os-itineraries__toolbar-info">
      <span class="mass-os-itineraries__record-count">
        <mat-icon class="mass-os-itineraries__count-icon">description</mat-icon>
        {{ itineraries.length }} file{{
          itineraries.length === 1 ? '' : 's'
        }} encontrado{{ itineraries.length === 1 ? '' : 's' }}
      </span>
      <span class="mass-os-itineraries__mode-help">
        Usa el paginador al final de la tabla para avanzar entre resultados.
      </span>
    </span>
  </div>

  <div class="mass-os-itineraries__loading" *ngIf="isLoading">
    <mat-progress-bar
      mode="indeterminate"
      color="accent"
      class="mass-os-itineraries__loading-bar"
    ></mat-progress-bar>
    <span class="mass-os-itineraries__loading-text">
      Cargando itinerarios...
    </span>
  </div>

  <table
    *ngIf="itineraries.length; else emptyState"
    mat-table
    [dataSource]="itineraries"
    multiTemplateDataRows
    class="mass-os-itineraries__table"
  >
    <ng-container matColumnDef="expand">
      <td mat-cell *matCellDef="let itinerary" class="mass-os-itineraries__expand">
        <button
          type="button"
          mat-icon-button
          class="mass-os-itineraries__chevron"
          [attr.aria-expanded]="isExpanded(itinerary)"
          [attr.aria-label]="
            (isExpanded(itinerary) ? 'Contraer ' : 'Expandir ') +
            itinerary.fileNumber
          "
          (click)="toggleExpand(itinerary); $event.stopPropagation()"
        >
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="Check">
      <td
        mat-cell
        *matCellDef="let itinerary"
        class="mass-os-itineraries__check"
      >
        <mat-checkbox
          [checked]="isItineraryChecked(itinerary)"
          [indeterminate]="isItineraryIndeterminate(itinerary)"
          (change)="toggleItinerary(itinerary, $event.checked)"
          (click)="$event.stopPropagation()"
        ></mat-checkbox>
      </td>
    </ng-container>

    <!-- Nombre compuesto: N° file ° agencia ° DS ° tipo cliente -->
    <ng-container matColumnDef="composite">
      <td
        mat-cell
        *matCellDef="let itinerary"
        class="mass-os-itineraries__composite"
      >
        <span class="mass-os-itineraries__file">{{
          itinerary.fileNumber
        }}</span>
        <span class="mass-os-itineraries__sep">°</span>
        <span class="mass-os-itineraries__agency">{{
          itinerary.agencia
        }}</span>
        <span class="mass-os-itineraries__sep">°</span>
        <span class="mass-os-itineraries__ds">{{ itinerary.usuario }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let itinerary"
        [attr.colspan]="columnsToDisplayWithExpand.length"
        [ngClass]="
          isExpanded(itinerary)
            ? 'mass-os-itineraries__detail-cell--open'
            : 'mass-os-itineraries__detail-cell'
        "
      >
        <app-mass-os-itinerary-services
          *ngIf="isExpanded(itinerary)"
          [servicios]="itinerary.servicios"
          [selectedIds]="selectedIdList"
          [selectedTickets]="selectedTickets"
          [expandAllTickets]="expandAllTickets"
          (toggleService)="onToggleService($event)"
          (ticketToggle)="onTicketToggle($event)"
        ></app-mass-os-itinerary-services>
      </td>
    </ng-container>

    <tr
      mat-row
      *matRowDef="let itinerary; columns: columnsToDisplayWithExpand"
      class="mass-os-itineraries__row"
      [class.mass-os-itineraries__row--expanded]="isExpanded(itinerary)"
      (click)="toggleExpand(itinerary)"
    ></tr>
    <tr
      mat-row
      *matRowDef="let itinerary; columns: ['expandedDetail']"
      class="mass-os-itineraries__detail-row"
    ></tr>
  </table>

  <div class="paginator-shell" *ngIf="itineraries.length > 0">
    <mat-paginator
      [length]="paginatorLength"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 50]"
      (page)="pageChange.emit($event)"
    ></mat-paginator>
  </div>

  <ng-template #emptyState>
    <div class="mass-os-itineraries__empty">
      <mat-icon class="mass-os-itineraries__empty-icon">inbox</mat-icon>
      <h3 class="mass-os-itineraries__empty-title">
        No hay files para el filtro seleccionado
      </h3>
      <p class="mass-os-itineraries__empty-text">
        Ajusta el proveedor, periodo o los servicios para ver los files
        programados disponibles.
      </p>
    </div>
  </ng-template>
</section>
